import React from 'react';
import { TextFieldStyled } from './text-field-form.styled';
import { useFormContext } from 'react-hook-form';
import { TextFieldProps } from '@mui/material';

type IProps = TextFieldProps & {
  noBorder?: boolean;
};
const TextFieldForm: React.FC<IProps> = ({ name, ...props }) => {
  const {
    register,
    formState: { errors, touchedFields },
  } = useFormContext();
  const registration = name && register(name);

  return (
    <TextFieldStyled
      error={!!(name && touchedFields?.[name] && errors?.[name])}
      inputProps={{
        helperText:
          name && touchedFields?.[name] && (errors?.[name]?.message as string),
      }}
      autoComplete="off"
      {...(registration && { ...registration })} // Register the field only if it is under FormProvider
      variant="outlined"
      {...props}
    />
  );
};

export default TextFieldForm;
